import { combineReducers } from '@reduxjs/toolkit';
import rolesReducer from './RoleManagement/RoleList/rolesSlice';
import manageCriteriaSetMatchingReducer from './SPManagement/redux/manageCriteriaSetMatchingSlice';
import userAccessManagementReducer from './UserAccessManagement/UserAccessManagementSlice';

const reducer = combineReducers({
  roleManagement: rolesReducer,
  manageCriteriaSetMatching: manageCriteriaSetMatchingReducer,
  UserAccessManagement: userAccessManagementReducer,
});

export default reducer;
